import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from "./store"
import { StripeCheckout } from 'vue-stripe'
import StandardSubscription from "./components/StandardSubscription.vue";
import GiftSubscription from "./components/GiftSubscription.vue";
import MultiSeatSubscription from "./components/MultiSeatSubscription.vue";
import "bootstrap-vue/dist/bootstrap-vue.css"
import "bootstrap/dist/css/bootstrap.min.css"

// Plugins
import SquarePlugin from './plugins/square';
import FireBasePlugin from './plugins/firebase';
import WallkitPlugin from './plugins/wallkit';

Vue.use(WallkitPlugin);
Vue.use(SquarePlugin);
Vue.use(FireBasePlugin);
Vue.use(BootstrapVue);
Vue.component('stripe-checkout', StripeCheckout);
Vue.component('standard-subscription', StandardSubscription);
Vue.component('gift-subscription', GiftSubscription);
Vue.component('multi-seat-subscription', MultiSeatSubscription);
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js